(function(){
    angular
        .module('app')
        .directive('ngModificarcentro', modificarcentro);

        modificarcentro.$inject = ['$timeout'];
        function modificarcentro($timeout){
            return {
	            templateUrl: '/uranolab/modificarcentro?lang_id='+lang_id,
		          scope: {
		          	appvm:"="
	              },
            	link: function (scope, element, $attrs, ngModel) {
		            return $timeout(function () {
                    	scope.horaTarde = function(horario){
                          horario.push({});
                      	}

                      	 scope.setHoras = function(){

				            var x = 30; //minutes interval
				            var times = []; // time array
				            var tt = 0; // start time

				            for (var i=0;tt<24*60; i++) {
				              var hh = Math.floor(tt/60); 

				              var mm = (tt%60); // getting minutes of the hour in 0-30 format
				              times[i] = ("0" + (hh % 24)).slice(-2) + ':' + ("0" + mm).slice(-2) + [Math.floor(hh/24)]; // pushing data in array in [00:00 - 12:00 AM/PM format]
				              tt = tt + x;
				              times[i]= times[i].slice(0,5);
				            }

				            //console.log(times);
				            return times;
				          }
				          scope.horas = scope.setHoras();

                      	scope.addVet = function(){
                      		console.log("addvet");
				            if(typeof(scope.appvm.info.centros[0].veterinariosCentro)=='undefined'){
				                scope.appvm.info.centros[0].veterinariosCentro = [];
				            }
				        	scope.appvm.info.centros[0].veterinariosCentro.push({ nombre:"" , apellidos:"", email:"", limps_id_col: "" });
				        }
				        var swiper = new Swiper('.swiper-container', {
			                slidesPerView: 'auto',
			                preloadImages: false,
			                lazyLoading: true,
			                paginationClickable: true,
			                spaceBetween: 16,
			                speed : 600,
			                effect: 'slide',
			                loop: false,
							scrollbar: {
							    el: '.swiper-scrollbar',
							    draggable: true,
							},			            
						});
						$.material.init();
		            });
		        }
          }
      	}
})();